export const BasicImageFileUploadTypes = new Set(["image/jpeg", "image/png", "image/webp"]);

const ValidFileUploadTypes = new Set([
	"image/jpeg",
	"image/png",
	"image/gif",
	"image/tiff",
	"image/webp",
	"image/raw",
	"image/avif",
	"image/x-canon-cr2",
	"image/x-nikon-nef",
	"image/x-sony-arw",
	"image/heic",
	"image/heif",
	"image/x-adobe-dng",
	"video/mp4",
	"video/quicktime",
	"video/mpeg",
	"video/avi",
	"video/webm",
	"video/x-flv",
	"video/x-matroska",
	"video/x-ms-wmv",
]);
export const ValidFileUploadExtensions = new Set([
	"jpg",
	"jpeg",
	"png",
	"gif",
	"tiff",
	"webp",
	"raw",
	"cr2",
	"nef",
	"arw",
	"heic",
	"heif",
	"dng",
	"mp4",
	"qt",
	"mpeg",
	"avi",
	"webm",
	"flv",
	"mkv",
	"wmv",
]);
export default ValidFileUploadTypes;
